import React, { forwardRef, useRef, useImperativeHandle } from "react";
import styled from "styled-components";
import NextBtn from './next';
import { jumpTo } from '@/utils';

const Page5 = ({ data, onNext }, ref) => {

  const containerRef = useRef();

  useImperativeHandle(ref, () => {
    return {
      shareContainer() {
        return containerRef.current
      }
    }
  });

  const handleDetail = () => {
    jumpTo(`storm://app/stock/detail?stockcode=${data.mostCheckStock.stockCode}`)
  }

  return (
    <Container className="page page1" ref={containerRef}>
      {!!data.checkStockCount && (
        <div className="data-wrap">
          <div className="user-data">2025这一年</div>
          <div className="user-data">
            你查看了<span className="light-data">{data.checkStockCount}</span>只个股
          </div>
          <div className="user-data">
            超越了<span className="light-data">{data.checkStockX}%</span>的风云用户
          </div>
          {data.mostCheckStock && data.mostCheckStock.stockName && (
            <div className="user-data" onClick={handleDetail}>
              你查看次数最多的个股是<span className="light-data">{data.mostCheckStock.stockName}</span>
            </div>
          )}
          <div className="user-data">{(!data.mostCheckStock || !data.mostCheckStock.stockName) ? '你对25年的哪只个股印象最深刻呢？' : '这只个股一定对你有特殊意义吧？'}</div>
          <img className="award-tip" src="https://file.wogoo.com/image/activity/active_205/award-tip@2x.png" alt="" />
        </div>
      )}
      {!data.checkStockCount && (
        <div className="data-wrap">
          <div className="user-data">2025年10月28日</div>
          <div className="user-data">
            大盘突破<span className="light-data">4000</span>点
          </div>
          <div className="user-data">3000点到4000点，只用了<span className="light-data">6</span>个月！</div>
        </div>
      )}

      <div className="data-bg">
        <img
          className="logo-img"
          src="https://file.wogoo.com/image/activity/active_205/page5-bg@2x.png"
          alt=""
        />
      </div>
      <div className="data-bg">
        <img className="logo-img" src="https://file.wogoo.com/image/activity/active_205/bottom-arrow@2x.png" alt=""/>
      </div>
      <div className="page-logo">
        <img className="logo-img" src="https://file.wogoo.com/image/activity/active_205/page-logo@2x.png" alt=""/>
      </div>
      <NextBtn onClick={onNext} />
    </Container>
  );
};

const Container = styled.div``;

export default React.memo(forwardRef(Page5));



// WEBPACK FOOTER //
// ./src/views/activity_205/page5.js